<template>
  <div class="auth-page">
    <div class="auth-container">
      <div class="auth-logo">
        <a href="/">
          <img :src="logoUrl" alt="ORLEY COSMETICS" />
        </a>
      </div>
      
      <div class="auth-card">
        <div class="auth-header">
          <h1>Reset Password</h1>
          <p>Enter your new password</p>
        </div>
        
        <form @submit.prevent="handleSubmit" class="auth-form">
          <div class="form-group">
            <label>Email Address *</label>
            <input 
              v-model="form.email" 
              type="email" 
              placeholder="Enter your email"
              required
            >
            <span v-if="errors.email" class="error">{{ errors.email[0] }}</span>
          </div>

          <div class="form-group">
            <label>New Password *</label>
            <div class="password-input-wrapper">
              <input 
                v-model="form.password" 
                :type="showPassword ? 'text' : 'password'" 
                placeholder="Enter new password"
                required
              >
              <button type="button" class="password-toggle" @click="showPassword = !showPassword">
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
            <span v-if="errors.password" class="error">{{ errors.password[0] }}</span>
          </div>

          <div class="form-group">
            <label>Confirm Password *</label>
            <div class="password-input-wrapper">
              <input 
                v-model="form.password_confirmation" 
                :type="showConfirmPassword ? 'text' : 'password'" 
                placeholder="Confirm new password"
                required
              >
              <button type="button" class="password-toggle" @click="showConfirmPassword = !showConfirmPassword">
                <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
          </div>

          <button type="submit" class="btn-submit" :disabled="loading">
            {{ loading ? 'Resetting...' : 'Reset Password' }}
          </button>
        </form>

        <div class="auth-footer">
          <p>Remember your password? 
            <a href="/login">Login</a>
          </p>
        </div>

        <div v-if="successMessage" class="rounded-md border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700">
          {{ successMessage }}
        </div>
        
        <div v-if="errorMessage" class="rounded-md border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  props: {
    token: {
      type: String,
      required: true
    },
    email: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      logoUrl: '/logos/logodark.svg',
      form: {
        email: this.email || '',
        password: '',
        password_confirmation: '',
        token: this.token
      },
      showPassword: false,
      showConfirmPassword: false,
      errors: {},
      loading: false,
      successMessage: '',
      errorMessage: ''
    }
  },
  methods: {
    async handleSubmit() {
      this.loading = true
      this.errors = {}
      this.errorMessage = ''
      this.successMessage = ''
      
      try {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
        
        const response = await fetch('/password/reset', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify(this.form)
        })
        
        const data = await response.json()
        
        if (response.ok) {
          this.successMessage = data.message || 'Password reset successfully! Redirecting to login...'
          setTimeout(() => {
            window.location.href = '/login'
          }, 1500)
        } else {
          if (data.errors) {
            this.errors = data.errors
          }
          this.errorMessage = data.message || 'Failed to reset password. Please try again.'
        }
      } catch (error) {
        this.errorMessage = 'An error occurred. Please try again.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

